import { useEffect } from "react";
import { APIProvider, Map, Marker, useMap } from "@vis.gl/react-google-maps";

const PIN_SVG = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="44" viewBox="0 0 32 44"><path d="M16 0C7.2 0 0 7.2 0 16c0 12 16 28 16 28s16-16 16-28C32 7.2 24.8 0 16 0z" fill="#F59E0B" stroke="#0B0F17" stroke-width="2"/><circle cx="16" cy="15" r="6" fill="#0B0F17"/></svg>'
);

function FitBounds({ pins }) {
  const map = useMap();
  useEffect(() => {
    if (!map || pins.length === 0) return;
    if (pins.length === 1) {
      map.setCenter({ lat: pins[0].lat, lng: pins[0].lng });
      map.setZoom(10);
      return;
    }
    const lats = pins.map((p) => p.lat);
    const lngs = pins.map((p) => p.lng);
    const latSpan = Math.max(...lats) - Math.min(...lats);
    const lngSpan = Math.max(...lngs) - Math.min(...lngs);
    const span = Math.max(latSpan, lngSpan);
    // ~280deg of latitude fits the map height at zoom 1; keep all pins in frame
    const zoom = Math.max(4, Math.min(10, Math.floor(Math.log2(280 / Math.max(span, 0.2)))));
    map.setCenter({
      lat: (Math.max(...lats) + Math.min(...lats)) / 2,
      lng: (Math.max(...lngs) + Math.min(...lngs)) / 2,
    });
    map.setZoom(zoom);
  }, [map, pins]);
  return null;
}

export default function DealerMap({ locations, onSelect }) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) return null;
  const pins = locations.filter((l) => typeof l.lat === "number" && typeof l.lng === "number");
  if (pins.length === 0) return null;
  return (
    <div className="h-[420px] w-full" data-testid="dealer-map">
      <APIProvider apiKey={apiKey}>
        <Map
          style={{ width: "100%", height: "100%" }}
          defaultCenter={{ lat: 39.5, lng: -98.35 }}
          defaultZoom={4}
          gestureHandling="greedy"
          disableDefaultUI
          zoomControl
        >
          {pins.map((l) => (
            <Marker
              key={l.id}
              position={{ lat: l.lat, lng: l.lng }}
              title={l.company}
              icon={{ url: `data:image/svg+xml,${PIN_SVG}`, scaledSize: { width: 32, height: 44 } }}
              onClick={() => onSelect?.(l)}
            />
          ))}
          <FitBounds pins={pins} />
        </Map>
      </APIProvider>
    </div>
  );
}
